import React from "react";
import { Spinner } from "react-bootstrap";

const TableLoader = ({
  message = "Loading data...",
  size = "sm",
  messageClass="",
  spinnerClass="",
  ...spinnerProps
}) => {
  return (
    <div className="tableloaderContainer">
      <Spinner
        animation="border"
        size={size}
        role="status"
        aria-hidden="true"
        className={`${spinnerClass}`}
        {...spinnerProps}
      />
      <div className={`${messageClass} ms-2`}>{message}</div>
    </div>
  );
};

export default TableLoader;
